import { z } from 'zod';

const titles = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      name: z.string().min(1),
      originalName: z.string().nullish(),
    }),
  ),
});

export const parseTitleSearch = (response: unknown) => {
  const { data } = titles.parse(response);
  const seen = new Set<string>();
  return data
    .filter((title) => {
      if (seen.has(title.name)) return false;
      seen.add(title.name);
      return true;
    })
    .map((title) => ({ value: title.name, label: title.name, originalName: title.originalName?.trim() || undefined }));
};
